"use strict";

(function () {
  function maskPhone(value) {
    var digits = (value || '').replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits.length ? '(' + digits : '';
    if (digits.length <= 6) return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    if (digits.length <= 10) return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 6) + '-' + digits.slice(6);
    return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + '-' + digits.slice(7);
  }

  function firstName(value) {
    var trimmed = (value || '').trim();
    return trimmed ? trimmed.split(' ')[0] : 'tudo certo';
  }

  function setupModal(modal) {
    var form = modal.querySelector('[data-modal-nido-form]');
    if (!form || form.dataset.modalNidoBound) return;
    form.dataset.modalNidoBound = 'true';

    var nomeField = form.querySelector('[data-modal-nido-field="nome"]');
    var foneField = form.querySelector('[data-modal-nido-field="fone"]');
    var emailField = form.querySelector('[data-modal-nido-field="email"]');
    var errorEl = modal.querySelector('[data-modal-nido-error]');
    var formStep = modal.querySelector('[data-modal-nido-step="form"]');
    var successStep = modal.querySelector('[data-modal-nido-step="success"]');
    var successTitleEl = modal.querySelector('[data-modal-nido-success-title]');
    var footnoteEl = modal.querySelector('[data-modal-nido-footnote-el]');

    var successHeadingTpl = modal.dataset.modalNidoSuccessHeading || 'Falta um passo, {nome}';
    var footnoteTpl = modal.dataset.modalNidoFootnote || 'Também salvamos {email} na nossa lista.';

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    function clearError() {
      showError('');
    }

    if (foneField) {
      foneField.addEventListener('input', function () {
        foneField.value = maskPhone(foneField.value);
        clearError();
      });
    }

    [nomeField, emailField].forEach(function (field) {
      if (field) field.addEventListener('input', clearError);
    });

    function reset() {
      form.reset();
      clearError();
      if (formStep) formStep.hidden = false;
      if (successStep) successStep.hidden = true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var nome = nomeField ? nomeField.value.trim() : '';
      var fone = foneField ? foneField.value : '';
      var email = emailField ? emailField.value.trim() : '';

      if (!nome) {
        showError('Conta pra gente seu nome :)');
        return;
      }
      if (fone.replace(/\D/g, '').length < 10) {
        showError('Confira o número do WhatsApp com DDD.');
        return;
      }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        showError('Esse e-mail parece incompleto.');
        return;
      }

      clearError();

      var formData = new FormData(form);
      fetch(form.action, { method: 'POST', body: formData }).catch(function () {});

      if (successTitleEl) successTitleEl.textContent = successHeadingTpl.replace('{nome}', firstName(nome));
      if (footnoteEl) footnoteEl.textContent = footnoteTpl.replace('{email}', email);
      if (formStep) formStep.hidden = true;
      if (successStep) successStep.hidden = false;
    });

    var observer = new MutationObserver(function () {
      if (!modal.classList.contains('popup-open')) reset();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('[data-modal-nido]').forEach(setupModal);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
